import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// // Performance monitoring
// function sendToAnalytics(metric) {
//   // In production, you would send this to your analytics service
//   console.log("Performance metric:", metric);

//   // Example: Send to Google Analytics
//   // gtag('event', metric.name, {
//   //   value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
//   //   event_category: 'Web Vitals',
//   //   event_label: metric.id,
//   //   non_interaction: true,
//   // });
// }

// // Measure Core Web Vitals
// getCLS(sendToAnalytics);
// getFID(sendToAnalytics);
// getFCP(sendToAnalytics);
// getLCP(sendToAnalytics);
// getTTFB(sendToAnalytics);
